module.exports = __webpack_public_path__ + "static/media/massa-textura.ea5891de.webp";